import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function DataGridTable({
  teacherQcDetails,
  appliedUniversities,
  appliedTimelines,
  appliedTerms,
  appliedPrograms,
  selectedUniversities,
}) {
  // Destructure props here
  // // console.log("teacherQcDetails", appliedTerms,appliedUniversities,appliedTimelines, appliedPrograms);

  const navigate = useNavigate();

  const handleRowClick = (params) => {
    navigate(`/individualteacher`, {
      state: {
        teacherName: params.row.tname,
        teacherid: params.row.tid,
        appliedTerms: appliedTerms,
        appliedTimelines: appliedTimelines,
        appliedUniversities: appliedUniversities,
        appliedPrograms: appliedPrograms,
        selectedUniversities: appliedUniversities,
      },
    });
    // navigate(`/individualteacher`, { state: { teacherName: params.row.tname ,teacherid: params.row.tid,unit_id:params.row.unit_id, } });
  };

  // Dynamically generate rows from teacherQcDetails
  const rows =
    teacherQcDetails && teacherQcDetails.length > 0
      ? teacherQcDetails.map((teacher, index) => ({
          id: index + 1, // Unique ID for each row
          sno: index + 1, // Serial number
          tname: teacher.name, // Teacher name from teacherQcDetails
          tid: teacher.id,
          uid: teacher?.units_deployed?.unit_id,
          unitdeploy: teacher?.units_deployed?.unit_name,
          unit_id: teacher?.units_deployed?.unit_id,
          // university: teacher.university_name,
          averdurationthreshold: teacher.total_student,
          midtermsurvey: teacher?.average_mid_satisfaction_score || '0',
          endtermsurvey: teacher?.average_end_satisfaction_score || '0',
          gradingcompliance: teacher?.assessment_grading_score || '0',
        }))
      : []; // If teacherQcDetails is empty or null, return an empty array

  const columns = [
    {
      field: 'sno',
      headerName: 'S.no',
      width: 100,
      headerAlign: 'left',
      align: 'left',
      sortable: false, // Prevent sorting on S.No
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },
    {
      field: 'tname',
      headerName: 'Name',
      width: 200,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'unitdeploy',
      headerName: 'Unit',
      width: 250,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'averdurationthreshold',
      headerName: 'Active Students',
      flex: 2,
      minWidth: 150,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'midtermsurvey',
      headerName: 'Student Satisfaction - Mid Term',
      flex: 2,
      minWidth: 300,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'endtermsurvey',
      headerName: 'Student Satisfaction - End Term',
      flex: 2,
      minWidth: 300,
      headerAlign: 'center',
      align: 'center',
    },
    // {
    //   field: 'gradingcompliance',
    //   headerName: 'Grading Quality Score',
    //   flex: 2,
    //   minWidth: 200,
    //   headerAlign: 'center',
    //   align: 'center',
    // },
  ];

  const [paginationModel, setPaginationModel] = useState({
    page: 0, // Starts at the first page
    pageSize: 20, // Shows 20 rows by default
  });

  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pagination
        paginationModel={paginationModel}
        onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
        autoHeight
        rowCount={rows.length} // Ensure correct total row count
        pageSizeOptions={[20, 50, 100]} // Available page sizes
        onRowClick={handleRowClick}
        sx={{
          'fontFamily': 'Nunito Sans, sans-serif',
          'fontSize': '14px',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#ebebeb',
            color: '#000',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '6px',
            fontFamily: 'Nunito Sans, sans-serif',
          },
          '& .MuiDataGrid-cell': {
            padding: '6px',
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '14px',
          },
          '& .MuiDataGrid-row:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
          },
        }}
      />
    </div>
  );
}
